import { atom } from 'jotai'
import { atomFamily, atomWithStorage } from 'jotai/utils'

const DEFAULT_DRAWER_DATE_SYNC = true

const getDrawerDateSyncStorageKey = (userId: number) =>
  `dispatch-board-drawer-date-sync:${String(userId)}`

type Params = { userId: number }

/**
 * 配車板横スクロール時の配送依頼ドロワー日付追従設定Atom（ユーザー単位）
 * - localStorage で永続化
 */
export const dispatchBoardDrawerDateSyncAtomFamily = atomFamily(
  (params: Params) => {
    const storageKey = getDrawerDateSyncStorageKey(params.userId)

    const base = atomWithStorage<boolean>(storageKey, DEFAULT_DRAWER_DATE_SYNC)

    return atom(
      (get) => get(base),
      (_get, set, next: boolean) => set(base, next)
    )
  },
  (a, b) => a.userId === b.userId
)
